var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    className: "product-view",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#74797D",
    fillRule: "evenodd",
    d: "M13.417 4.212L18.87 6.94c.35.174.625.424.827.75.202.327.303.687.303 1.078v6.482c0 .392-.101.751-.303 1.078a2.003 2.003 0 0 1-.827.75l-5.453 2.71c-.284.142-.59.213-.917.213-.328 0-.633-.07-.917-.212l-5.47-2.727a2.011 2.011 0 0 1-.81-.759A2.022 2.022 0 0 1 5 15.232V8.768c0-.391.101-.75.303-1.077.202-.327.478-.577.827-.751l5.453-2.727c.284-.141.59-.212.917-.212.328 0 .633.07.917.212zm4.372 3.706l-4.978-2.481a.661.661 0 0 0-.606 0l-1.588.783 5.29 2.645 1.882-.947zm.852 1.094l-2.424 1.208v.017l-3.03 1.502v6.645l5.077-2.53a.684.684 0 0 0 .377-.605V9.012zm-6.829 9.372v-6.645L6.36 9.012v6.237c0 .12.036.237.107.351a.667.667 0 0 0 .27.253l5.076 2.53zM9.094 6.97l-1.883.947 5.289 2.645 1.883-.947-5.29-2.645z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductView);
export default __webpack_public_path__ + "static/media/product-view.405831b3c33545101f12a1b576fe2060.svg";
export { ForwardRef as ReactComponent };